import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import SwiperCore, { Pagination } from "swiper";
import { ChevronRight } from "lucide-react"; // You can also use any icon you prefer

SwiperCore.use([Pagination]);

const cardData = [
  {
    title: "QR Scan Ordering. Digital Menu",
    subtitle:
      "Let guests scan QR codes to view menus, place orders, and pay — no waiting for servers. Smooth, contactless dining experience.",
    image: "/images/galery/order-table-qr.jpg",
  },
  {
    title: "Automatic Loyalty Stamps.",
    subtitle:
      "Reward loyal customers with digital stamp cards that track visits automatically. Keep guests returning and grow your repeat business effortlessly.",
    image:
      "https://images.pexels.com/photos/12935064/pexels-photo-12935064.jpeg",
  },
  {
    title: "Automated Reminders.",
    subtitle:
      "Send booking reminders automatically via email to reduce no-shows and keep your tables full — while you focus on great service.",
    image: "https://images.pexels.com/photos/7439122/pexels-photo-7439122.jpeg",
  },
  {
    title: "Online Booking & Kitchen Printing.",
    subtitle:
      "Accept table reservations online, send orders directly to kitchen printers, and keep operations running smoothly — fully automated from booking to cooking.",
    image: "/images/galery/menubook.png",
  },
];

const ThirdRestaurant = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <div className="bg-black py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-semibold text-text mb-4">
          Happier guests. Smoother service.
        </h2>
        <p className="text-textGray text-lg max-w-3xl mx-auto">
          Keep tables full, orders flowing, and guests satisfied. With QR code
          menus, online reservations, and direct kitchen printing, Lokalai keeps
          your restaurant running like clockwork — while you focus on great food
          and service.
        </p>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="max-w-7xl mx-auto relative">
          <Swiper
            pagination={{ clickable: true }}
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 1.2 },
              768: { slidesPerView: 2.2 },
              1024: { slidesPerView: 3.2 },
              1280: { slidesPerView: 4.2 },
            }}
          >
            {cardData.map((card, index) => (
              <SwiperSlide key={index}>
                <div
                  className="bg-dry text-text rounded-3xl p-8 h-full flex flex-col justify-between shadow-xl min-h-[500px] cursor-pointer transition-all duration-300"
                  onClick={() => toggleExpand(index)}
                >
                  <div>
                    <h3 className="text-xl font-semibold whitespace-pre-line mb-4">
                      {card.title}
                    </h3>
                    <p
                      className={`text-sm mb-6 transition-all duration-300 ${
                        expandedCard === index ? "" : "line-clamp-3"
                      }`}
                    >
                      {card.subtitle}
                    </p>
                  </div>
                  <div className="w-full h-[300px] rounded-xl overflow-hidden mb-4">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-full h-full object-cover grayscale"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Conditional right arrow */}
          {cardData.length < 5 && (
            <div className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-lg cursor-pointer">
              <ChevronRight className="text-text" size={24} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThirdRestaurant;
